"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { installClientErrorTelemetry, recordNavigation } from "@/data/telemetry";

// Installed when this chunk evaluates rather than in an effect, so errors thrown while the rest of
// the page hydrates are caught too.
installClientErrorTelemetry();

/**
 * Starts reporting uncaught browser errors to the backend (PAT1-16082), and records page changes
 * for their breadcrumbs (PRD-012). Renders nothing; mount it once, in the root layout.
 *
 * The App Router has no router events, so page changes come from `usePathname()`. That makes this
 * one component re-render on navigation (PRD-012, D8).
 */
export const Container = () => {
  const pathname = usePathname();

  useEffect(() => {
    installClientErrorTelemetry();
  }, []);

  useEffect(() => {
    recordNavigation(pathname);
  }, [pathname]);

  return null;
};
